export default __webpack_public_path__ + "static/media/2292.e155724d.png";